const Style = {

  feature: 'pr-4',
  icon: 'relative float-left mt-1 mr-2',
  title: 'text-blue-500 font-semibold uppercase',
  description: 'mt-1 mb-3'

}

export default Style;